import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { CallForPapersViewModel, ConferenceViewModelWithDetails, PaperCustomQuestionAnswerViewModel, PaperError, PaperTypeViewModel, PaperViewModel, SurveyViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { CallForPapersService, ConferenceSurveyService, OrganizationService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AddPersonModalComponent } from './add-person-modal.component';
import { Model } from 'survey-core';
import { ComponentCollection, Question } from 'survey-core';

@Component({
  selector: 'bxl-call-for-papers',
  templateUrl: 'call-for-papers.component.html',
})
export class CallForPapersComponent implements OnInit {
  initialized = false;
  stage = 0;
  childStage = 0;
  formGroup: FormGroup;
  paperType: PaperTypeViewModel;
  model: CallForPapersViewModel;
  tempPaper: PaperViewModel;
  cvUploadUrl: string;
  paperTypes: PaperTypeViewModel[];
  conferenceId: any;
  conference: ConferenceViewModelWithDetails;
  editExisting: boolean;
  bypassDeadline: boolean;
  survey: SurveyViewModel;
  surveyModel: Model;
  surveryLoaded: boolean;

  constructor(private cfpService: CallForPapersService, private surveyService: ConferenceSurveyService, private orgService: OrganizationService, private activatedRoute: ActivatedRoute, private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private modalService: NgbModal, public auth: AuthenticationService, private toaster: ToasterService, public navService: NavigationService) {}

  ngOnInit(): void {
    this.cvUploadUrl = '/api/upload-cv';

    this.route.queryParamMap.subscribe((queryParams) => {
      this.route.paramMap.subscribe((params) => {
        this.conferenceId = params.get('conferenceSlug');

        console.log(params.get('conferenceSlug'));
        this.orgService.getConferenceBySlug(this.conferenceId).subscribe((conf) => {
          this.conference = conf;

          this.cfpService.getPaperTypesForConference(this.conferenceId).subscribe((result) => {
            if (queryParams.get('show-all')) {
              this.paperTypes = result;

            }else if(queryParams.get('bypass-deadline')){
              this.bypassDeadline = true;
              this.paperTypes = result.filter((x) => !x.hiddenFromDropdown);
            } else if (queryParams.get('invited')) {
              this.paperTypes = result.filter((x) => x.hiddenFromDropdown);
              this.bypassDeadline = true;
            } else if (queryParams.get('type')) {
              var type = queryParams.get('type').toLowerCase();
              console.log(type);
              this.paperTypes = result.filter((x) => x.title.toLowerCase() == queryParams.get('type').toLowerCase());
              this.bypassDeadline = true;
            } else {
              this.paperTypes = result.filter((x) => !x.hiddenFromDropdown);
            }

            console.log(this.conference);

            if (queryParams.has('paperId')) {
              this.editExisting = true;
              this.cfpService.getPaperState(this.conferenceId, +queryParams.get('paperId')).subscribe((sresult) => {
                this.model =sresult;

                if (!Enumerable.from(this.paperTypes).any((x) => x.id == this.model.paperTypeId)) {
                  this.paperTypes.push(Enumerable.from(result).first((x) => x.id == this.model.paperTypeId));
                }

                //temporary. Remove after backend fleshed out
                // this.model.papers = [];

                this.initialized = true;
              });
              //get model
            } else {
              this.model = new CallForPapersViewModel();
              this.model.panelists = [];
              this.model.paperCustomQuestionResponses = [];
              this.model.authors = [];
              this.model.presenters = [];
              this.model.childPapers = [];
              this.model.learningObjective1 = '';
              this.model.learningObjective2 = '';
              this.model.learningObjective3 = '';
              this.initialized = true;
            }
          });
        });
      });
    });
  }

  setInstructionsAndSaveProgress() {
    this.model.customSurveyJSON = JSON.stringify(this.surveyModel?.data);

    this.cfpService.savePaperState(this.conferenceId, this.model).subscribe((result) => {
      this.model.id = result.id;
      this.model.errors = result.errors;

      if (this.surveyModel?.hasErrors()) {
        var error = new PaperError();
        error.error = 'Additional Questions are Required!';
        error.step = 7;
        this.model.errors.push(error);
      }

      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { paperId: result.id },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    });
  }

  get didAgree() {
    if (!this.paperType.askForAcknowledgements) {
      return true;
    }

    var notChecked = this.conference.paperAcknowledgements.filter((x) => !x.checked);
    return notChecked.length == 0;
  }

  submitPaper() {
    this.cfpService.submitPaper(this.conferenceId, this.model).subscribe((result) => {
      this.toaster.messageDialog('This ' + this.paperType.title + ' has been submitted for review. You will receive an email confirmation shortly.', 'Success').subscribe((msgResult) => {
        this.router.navigate(['/account/paper-submissions']);
      });
    });
  }

  saveDraft() {
    this.cfpService.savePaperState(this.conferenceId, this.model).subscribe((result) => {
      this.toaster.messageDialog('This ' + this.paperType.title + ' has been saved as a draft. You can continue anytime from "my account"', 'Draft Saved').subscribe((msgResult) => {
        this.router.navigate(['/account/paper-submissions']);
      });
    });
  }

  compareByID(itemOne: PaperCustomQuestionAnswerViewModel, itemTwo: PaperCustomQuestionAnswerViewModel) {
    return itemOne && itemTwo && itemOne.id == itemTwo.id;
  }

  nextStage() {
    console.log(this.model.paperCustomQuestionResponses[0]);
    this.paperType = this.paperTypes.find((x) => x.id == this.model.paperTypeId);
    //console.log(this.paperType);
    // var sortedSteps = this.paperType.steps.sort((a, b) => (a.order > b.order ? 1 : -1));

    // var index = sortedSteps.findIndex((x) => x.stepNumber == this.stage);
    //var nextIndex = index + 1;
    //this.stage = sortedSteps[nextIndex].stepNumber;

    this.stage++;
    if (!this.paperType.askForCEUInfo && this.stage == 3) {
      this.nextStage();
    } else if (!this.paperType.askForChildPapers && this.stage == 5) {
      this.nextStage();
    } else if (!this.paperType.askForPaymentInfo && this.stage == 6) {
      this.nextStage();
    } else if (!this.paperType.askForAcknowledgements && this.stage == 8) {
      this.nextStage();
    } else if (this.paperType.customQuestionSurveyId == null && this.stage == 7) {
      this.nextStage();
    } else if (this.stage == 7) {
      this.loadSurvey();
    } else if (this.stage >= 3) {
      this.setInstructionsAndSaveProgress();
    }

    console.log(this.stage);
  }

  loadSurvey() {
    console.log('surveys');
    if (this.surveryLoaded) {
      return;
    }

    this.surveyService.getSurveyById(this.conference.organizationId.toString(), this.conference.id, this.paperType.customQuestionSurveyId).subscribe((result) => {
      this.survey = result;
      const survey = new Model(JSON.parse(result.schemaJSON));
      this.surveyModel = survey;
      this.surveyModel.isSinglePage = true
      this.surveyModel.showNavigationButtons = false;
      this.surveyModel.questionsOnPageMode = 'singlePage';
      this.surveyModel.mode = 'edit';

      console.log(survey.getAllQuestions());
      this.updateQuestionsFromAuth();
      this.surveryLoaded = true;
    });
  }

  updateQuestionsFromAuth() {
    var questions = Enumerable.from(this.surveyModel.getAllQuestions());
    questions.forEach((question: Question) => {
      if (question.customQuestion?.name == 'bxlfirstname') {
        this.surveyModel.setValue(question.name, this.auth.user?.firstName);
      }

      if (question.customQuestion?.name == 'bxllastname') {
        this.surveyModel.setValue(question.name, this.auth.user?.lastName);
      }

      if (question.customQuestion?.name == 'bxlemail') {
        this.surveyModel.setValue(question.name, this.auth.user?.email);
      }

      console.log(question.customQuestion?.name);
    });
  }

  previousStage() {
    this.stage--;
    if (!this.paperType.askForCEUInfo && this.stage == 3) {
      this.previousStage();
    } else if (!this.paperType.askForChildPapers && this.stage == 5) {
      this.previousStage();
    } else if (!this.paperType.askForPaymentInfo && this.stage == 6) {
      this.previousStage();
    } else if (!this.paperType.askForAcknowledgements && this.stage == 8) {
      this.previousStage();
    } else if (this.paperType.customQuestionSurveyId == null && this.stage == 7) {
      this.previousStage();
    } else {
      this.setInstructionsAndSaveProgress();
    }
  }

  goToStage(num: number) {
    this.paperType = this.paperTypes.find((x) => x.id == this.model.paperTypeId);
    this.stage = num;
    this.setInstructionsAndSaveProgress();
  }

  addPerson(type: string, self: boolean) {
    const modalRef = this.modalService.open(AddPersonModalComponent, { size: 'lg', keyboard: false, ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.personType = type;
    modalRef.componentInstance.conferenceId = this.conference.id;

    if (self) {
      modalRef.componentInstance.instructorId = this.auth.user.id;
    }
    modalRef.result.then(
      (result) => {},
      (instructor) => {
        switch (type) {
          case 'Discussant':
            this.model.discussant = instructor;
            break;
          case 'Chair':
            this.model.chair = instructor;
            break;
          case 'Panelist':
            this.model.panelists.push(instructor);
            break;
          case 'Presenter':
            this.model.presenters.push(instructor);
            break;
          case 'Author':
            this.model.authors.push(instructor);
            break;
          case 'ChildPresenter':
            this.tempPaper.presenter = instructor;
            break;
          case 'ChildAuthor':
            this.tempPaper.authors.push(instructor);
            break;
        }
      }
    );
  }

  editPerson(type: string, id: number) {
    const modalRef = this.modalService.open(AddPersonModalComponent, { size: 'lg', keyboard: false, ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.personType = type;
    modalRef.componentInstance.instructorId = id;
    modalRef.componentInstance.conferenceId = this.conference.id;

    modalRef.result.then(
      (result) => {},
      (instructor) => {
        switch (type) {
          case 'Discussant':
            this.model.discussant = instructor;
            break;
          case 'Chair':
            this.model.chair = instructor;
            break;
          case 'Panelist':
            var index = this.model.panelists.findIndex((x) => x.id == id);
            if (index > -1) {
              this.model.panelists[index] = instructor;
            } else {
              this.model.panelists.push(instructor);
            }
            break;
          case 'Presenter':
            var index = this.model.presenters.findIndex((x) => x.id == id);
            if (index > -1) {
              this.model.presenters[index] = instructor;
            } else {
              this.model.presenters.push(instructor);
            }
            break;
          case 'Author':
            var index = this.model.authors.findIndex((x) => x.id == id);
            if (index > -1) {
              this.model.authors[index] = instructor;
            } else {
              this.model.authors.push(instructor);
            }
            break;
          case 'ChildPresenter':
            this.tempPaper.presenter = instructor;
            break;
          case 'ChildAuthor':
            var index = this.tempPaper.authors.findIndex((x) => x.id == id);
            if (index > -1) {
              this.tempPaper.authors[index] = instructor;
            } else {
              this.tempPaper.authors.push(instructor);
            }
            break;
        }
      }
    );
  }
  removePerson(type: string, id: number) {
    switch (type) {
      case 'Discussant':
        this.model.discussant = null;
        break;
      case 'Chair':
        this.model.chair = null;
        break;
      case 'Panelist':
        var index = this.model.panelists.findIndex((x) => x.id == id);
        this.model.panelists.splice(index, 1);
        break;
      case 'Presenter':
        var index = this.model.presenters.findIndex((x) => x.id == id);
        this.model.presenters.splice(index, 1);
        break;
      case 'Author':
        var index = this.model.authors.findIndex((x) => x.id == id);
        this.model.authors.splice(index, 1);
        break;
      case 'ChildPresenter':
        this.tempPaper.presenter = null;
        break;
      case 'ChildAuthor':
        var index = this.tempPaper.authors.findIndex((x) => x.id == id);
        this.tempPaper.authors.splice(index, 1);
        break;
    }
  }

  addPaper() {
    this.tempPaper = new PaperViewModel();
    this.tempPaper.authors = [];
    this.goToStage(99);
  }

  savePaper() {
    let index = this.model.childPapers.indexOf(this.tempPaper);
    if (index > -1) {
      this.model.childPapers[index] = this.tempPaper;
    } else {
      this.model.childPapers.push(this.tempPaper);
    }
    this.tempPaper = null;
    this.goToStage(5);
  }

  editPaper(paper: PaperViewModel) {
    let index = this.model.childPapers.indexOf(paper);
    this.tempPaper = this.model.childPapers[index];
    this.goToStage(99);
  }

  removePaper(paper: PaperViewModel) {
    let index = this.model.childPapers.indexOf(paper);
    this.model.childPapers.splice(index, 1);
    this.tempPaper = null;
  }

  successEventHandler(e) {
    // Get the file URI from the response
    this.model.cvAssetPath = e.response.body.name;
  }

  dataAssetSuccessEventHandler(e) {
    // Get the file URI from the response
    this.model.dataAssetPath = e.response.body.name;
  }
}
